module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1r9r7n4n-1884f6c47491e7e47ef3c80d97327d03.svg";